"use client";

import { useAppContext } from "@/context/AppContext";
import { renderButtonContent } from "./ExtendedLink";
import { Button } from "../Button/Button";

type BookingButtonProps = {
  extraClass?: string;
  linkLabel?: string;
};

export const BookingButton = ({
  extraClass,
  linkLabel,
}: BookingButtonProps) => {
  const { setBookingModal } = useAppContext();
  if (!linkLabel) return null;
  return (
    <Button
      type={"primary"}
      href={""}
      target=""
      onClick={() => {
        setBookingModal({ open: true });
      }}
      className={extraClass}
      isBooking={true}
    >
      {renderButtonContent(linkLabel)}
    </Button>
  );
};
